export default __webpack_public_path__ + "static/media/Arsalan_Ahmed.4ac3f610.png";